import { useCellValues, usePublisher } from "@mdxeditor/gurx";
import { activeEditor$, cancelLinkEdit$, editorRootElementRef$, iconComponentFor$, linkDialogState$, onWindowChange$, updateLink$ } from "@mdxeditor/editor";
import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, } from '@chakra-ui/react';
import React, { useEffect, useState } from "react";
export const MarkdownLinkDialog = () => {
    const [editorRootElementRef, activeEditor, iconComponentFor, linkDialogState] = useCellValues(editorRootElementRef$, activeEditor$, iconComponentFor$, linkDialogState$);
    const publishWindowChange = usePublisher(onWindowChange$);
    const updateLink = usePublisher(updateLink$);
    const cancelLinkEdit = usePublisher(cancelLinkEdit$);
    const [title, setTitle] = useState("");
    const [url, setUrl] = useState("");
    const save = () => {
        updateLink({ url, title });
    };
    useEffect(() => {
        if ("url" in linkDialogState && linkDialogState.url !== url) {
            setUrl(linkDialogState.url);
        }
        if ("title" in linkDialogState && linkDialogState.title !== title) {
            setTitle(linkDialogState.title);
        }
    }, [linkDialogState]);
    return (React.createElement(Modal, { isOpen: linkDialogState.type === "edit", onClose: () => cancelLinkEdit() },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null, "Edit Link"),
            React.createElement(ModalCloseButton, null),
            React.createElement(ModalBody, null,
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Title"),
                    React.createElement(Input, { value: title, onChange: e => setTitle(e.target.value) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "URL"),
                    React.createElement(Input, { value: url, onChange: e => setUrl(e.target.value) }))),
            React.createElement(ModalFooter, { display: "flex", gap: 4 },
                React.createElement(Button, { colorScheme: "gray", onClick: () => cancelLinkEdit() }, "Close"),
                React.createElement(Button, { colorScheme: 'brand', onClick: () => save() }, "Save")))));
};
